import { render, staticRenderFns } from "./xiaoyumi.vue?vue&type=template&id=2e0ad465&scoped=true&"
import script from "./xiaoyumi.vue?vue&type=script&lang=js&"
export * from "./xiaoyumi.vue?vue&type=script&lang=js&"
import style0 from "./xiaoyumi.vue?vue&type=style&index=0&id=2e0ad465&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0ad465",
  null
  
)

export default component.exports